module.exports = __webpack_public_path__ + "static/media/tharu-tika-cover.424fec67.png";